// errorMessages.js
export const ERROR_MESSAGES = {

    // Login Error Messages'
    LOGIN: {
        DEFAULT: '予期しないエラーが発生しました。',
        INVALID_CREDENTIALS: 'メールアドレスまたはパスワードが正しくありません。',
        UNVERIFIED_OR_SUSPENDED: 'メールアドレスが未確認、またはアカウントが停止されています。',
    },

    // Signup Error Messages
    SIGNUP: {
        DEFAULT: '予期しないエラーが発生しました。',
        REQUIRED_FIELDS: '必須項目をすべて入力してください。',
        EMAIL_ALREADY_EXISTS: 'このメールアドレスは既に登録されています。',
        PASSWORD_WEAK: 'パスワードが弱すぎます。',
        NETWORK_ERROR: 'ネットワークエラーが発生しました。',
        UNKNOWN: 'サインアップ中にエラーが発生しました。',
    },

    // Forgot Password Messages
    FORGOT_PASSWORD: {
        DEFAULT: '予期しないエラーが発生しました。',
        INVALID_EMAIL: '有効なメールアドレスを入力してください。',
        EMAIL_NOT_FOUND: 'このメールアドレスは登録されていません。',
        NETWORK_ERROR: 'ネットワークエラーが発生しました。',
        OTP_SENT: '再設定コード（OTP）を送信しました。メールをご確認ください。',
    },

    // Reset Password message 
    RESET_PASSWORD: {
        DEFAULT: '予期しないエラーが発生しました。',
        INVALID_EMAIL: 'メールアドレスを入力してください。',
        INVALID_CODE: '確認コード (OTP) を入力してください。',
        PASSWORD_REQUIRED: '新しいパスワードと確認用パスワードを入力してください。',
        PASSWORD_MISMATCH: 'パスワードが一致しません。',
        PASSWORD_WEAK: 'パスワードは8文字以上で、英字と数字を含めてください。',
        EXPIRED_OR_INVALID_CODE: '確認コードが無効または期限切れです。',
        NETWORK_ERROR: 'ネットワークエラーが発生しました。',
        SUCCESS: 'パスワードが更新されました。ログインしてください。',
    },

    // Otp Verify Message
    OTP: {
        DEFAULT: '予期しないエラーが発生しました。',
        INVALID_EMAIL: 'メールアドレスを入力してください。',
        INVALID_CODE: '有効な確認コードを入力してください。',
        EXPIRED_OR_INCORRECT: '確認コードが無効または期限切れです。',
        RESEND_FAILED: '再送信に失敗しました。',
        RESEND_SUCCESS: '再送信しました。コードが届くまでお待ちください。',
        NETWORK_ERROR: 'ネットワークエラーが発生しました。',
        VERIFIED_SUCCESS: '確認に成功しました。',
    },


};
